import React from "react";
import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";

// 效果 13: 打字机效果
export const TypewriterEffect: React.FC<{ text: string }> = ({ text }) => {
  const frame = useCurrentFrame();
  const charsToShow = Math.floor(
    interpolate(frame, [0, 90], [0, text.length], {
      extrapolateRight: "clamp",
    })
  );
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0f0f23",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontSize: 80,
          color: "white",
          fontFamily: "monospace",
        }}
      >
        {text.slice(0, charsToShow)}
        <span
          style={{
            opacity: Math.sin(frame * 0.5) > 0 ? 1 : 0,
            color: "#4ecdc4",
          }}
        >
          |
        </span>
      </div>
    </AbsoluteFill>
  );
};

// 效果 14: 逐字飞入
export const FlyInLetters: React.FC<{ text: string }> = ({ text }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#1a1a2e",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ display: "flex", fontSize: 80 }}>
        {text.split("").map((char, i) => {
          const delay = i * 5;
          const progress = spring({
            frame: frame - delay,
            fps,
            config: { damping: 12, stiffness: 200 },
          });
          
          return (
            <div
              key={i}
              style={{
                color: "white",
                transform: `
                  translateY(${interpolate(progress, [0, 1], [100, 0])}px)
                  rotate(${interpolate(progress, [0, 1], [-180, 0])}deg)
                `,
                opacity: progress,
              }}
            >
              {char}
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

// 效果 15: 波浪文字
export const WaveText: React.FC<{ text: string }> = ({ text }) => {
  const frame = useCurrentFrame();
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#16213e",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ display: "flex", fontSize: 80 }}>
        {text.split("").map((char, i) => {
          const y = Math.sin(frame * 0.1 + i * 0.5) * 30;
          
          return (
            <div
              key={i}
              style={{
                color: `hsl(${(i * 360) / text.length}, 70%, 60%)`,
                transform: `translateY(${y}px)`,
              }}
            >
              {char}
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

// 效果 16: 震动文字
export const ShakeText: React.FC<{ text: string }> = ({ text }) => {
  const frame = useCurrentFrame();
  
  const intensity = interpolate(
    frame,
    [0, 30, 90, 120],
    [0, 10, 10, 0],
    { extrapolateRight: "clamp" }
  );
  
  const x = (Math.random() - 0.5) * intensity * 2;
  const y = (Math.random() - 0.5) * intensity * 2;
  
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#0a0a0a",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontSize: 80,
          color: "#ff6b6b",
          fontWeight: "bold",
          transform: `translate(${x}px, ${y}px)`,
        }}
      >
        {text}
      </div>
    </AbsoluteFill>
  );
};

// 效果 17: 缩放文字
export const ScaleText: React.FC<{ text: string }> = ({ text }) => {
  const frame = useCurrentFrame();
  const scale = 1 + Math.sin(frame * 0.1) * 0.3;

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#1a1a2e",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          fontSize: 80,
          color: "#4ecdc4",
          fontWeight: "bold",
          transform: `scale(${scale})`,
        }}
      >
        {text}
      </div>
    </AbsoluteFill>
  );
};
